// extracted by mini-css-extract-plugin
module.exports = {"pagination--desktopOnly":"Pagination_pagination--desktopOnly__Imvcg","pagination--centred":"Pagination_pagination--centred__OP11B"};